import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import OopBuyGuide from "../pages/oopbuy-spreadsheet-guide/page";
import OopBuyBuyingGuide from "../pages/oopbuy-spreadsheet-buying-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/oopbuy-spreadsheet-guide",
    element: <OopBuyGuide />,
  },
  {
    path: "/oopbuy-spreadsheet-buying-guide",
    element: <OopBuyBuyingGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;